import { Pipe, PipeTransform } from "@angular/core";
import { KeyViewModel } from "../../admin-panel/Keys/Model/KeyViewModel";
import { GroupFilterModel } from "./FilterByNameAndGroup.pipe";

@Pipe({
    name: 'keysFilter',
    pure: false,
    standalone: false
})
export class FilterKeysPipe implements PipeTransform
{
  transform(items: KeyViewModel[], filter: GroupFilterModel): any
  {
    if (!items) return [];

    if (filter.term && filter.term != "") {
      var filteredItems = [];
      let lowerCaseTerm = filter.term.toLowerCase();
      for (let i = 0; i < items.length; i++)
        if (items[i].Name.toLowerCase().indexOf(lowerCaseTerm) >= 0 || items[i].UID.toLowerCase().indexOf(lowerCaseTerm) >= 0 || items[i].Comment.toLowerCase().indexOf(lowerCaseTerm) >= 0)
          filteredItems.push(items[i]);
        //else
          //items[i].IsChecked = false;

      items = filteredItems;
    }

    if (filter.group && filter.group.Id > 0) {
      let groupIDs = {};
      for (let i = 0; i < filter.group.objects.length; i++)
        groupIDs[filter.group.objects[i]] = 1;

      var filteredItems = [];
      for (let i = 0; i < items.length; i++)
        if (groupIDs[items[i].Id])
          filteredItems.push(items[i]);
        //else
          //items[i].IsChecked = false;
      return filteredItems;
    }
    return items;
  }
}
